module.exports = __webpack_public_path__ + "static/img/COOPER-DUFF-TYTLER.c24c078.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/COOPER-DUFF-TYTLER.jpg
// module id = TjNl
// module chunks = 0